import { isCODWithoutPartialPayment } from "../../utils/order.util";

const serviceChargeMapping = {
  cc: (deliveryOption) => (deliveryOption && deliveryOption.key === "international" ? 4.99 : 3.03),
  dc: (price, deliveryOption) =>
    deliveryOption && deliveryOption.key === "international" ? 4.99 : price > 2000 ? 2.28 : 2.0,
  upi: (price, cohort) => {
    const hasCohort5 = cohort && Array.isArray(cohort) && cohort.includes(5);
    return price > 600 ? (hasCohort5 ? 2.0 : 1.75) : 2.18;
  },
  app: 2.98,
  nb: 2.93,
  bnpl: 5.0,
};

const truncateTo2Decimals = (num) => {
  if (num == null) return null;
  return Math.floor(num * 100) / 100;
};

const getApplicableProcessingFee = (processingFee, processingFeePayee) => {
  if (!processingFeePayee) {
    return processingFee;
  } else if (processingFeePayee !== "self") {
    return processingFee;
  }

  return 0;
};
const getPrice = (deliveryOption, cart, paymentMode = null, processingFeePayee, cohort = null) => {
  const partialPaymentPercentage = deliveryOption.partialPaymentPercentage;
  let calculatedPrice = 0;
  let shippingFeeApplied = false;
  let shippingFee = deliveryOption.shippingCharge;
  let discountedAmount = cart?.discountedAmount;
  let couponId, couponCode;
  let partialPaymentPrice = null;

  if (discountedAmount) {
    couponId = cart.couponId;
    couponCode = cart.couponCode;
  }
  const actualShippingFee = cart.shippingFee;
  const shippingFeeCap = Number.isInteger(cart.shippingFeeCap)
    ? cart.shippingFeeCap
    : Number.MAX_SAFE_INTEGER;
  for (const product of cart.products) {
    const productQuantity = product.quantity ? product.quantity : 1;
    calculatedPrice += product.price * productQuantity;
  }

  let priceWithoutFees = calculatedPrice;
  if (discountedAmount) {
    calculatedPrice = priceWithoutFees - discountedAmount;
  }

  if (calculatedPrice < shippingFeeCap) {
    calculatedPrice += shippingFee ? shippingFee : 0;
    shippingFeeApplied = true;
  } else {
    shippingFee = 0;
  }

  const productTotalPrice = calculatedPrice;

  let processingFee = 0;
  if (isCODWithoutPartialPayment(deliveryOption)) {
    processingFee = 0;
  } else if (paymentMode === "dc") {
    processingFee = Number(
      (
        calculatedPrice *
        (serviceChargeMapping[paymentMode](calculatedPrice, deliveryOption) / 100)
      ).toFixed(2),
    );
  } else if (paymentMode === "cc") {
    processingFee = Number(
      (calculatedPrice * (serviceChargeMapping[paymentMode](deliveryOption) / 100)).toFixed(2),
    );
  } else if (paymentMode) {
    const serviceCharge = serviceChargeMapping[paymentMode];

    if (typeof serviceCharge === "function") {
      // For UPI, pass cohort as second parameter; for other payment modes, pass appropriate parameters
      if (paymentMode === "upi") {
        processingFee = Number(
          (calculatedPrice * (serviceCharge(calculatedPrice, cohort) / 100)).toFixed(2),
        );
      } else {
        processingFee = Number(
          (calculatedPrice * (serviceCharge(calculatedPrice) / 100)).toFixed(2),
        );
      }
    } else {
      // Handle cases where serviceCharge is a number (like app, nb)
      processingFee = Number((calculatedPrice * (serviceCharge / 100)).toFixed(2));
    }
  } else {
    processingFee = Number((calculatedPrice * 0.02).toFixed(2));
  }
  processingFee++;

  const pricewithShipping = calculatedPrice;

  calculatedPrice += getApplicableProcessingFee(processingFee, processingFeePayee);

  if (partialPaymentPercentage) {
    partialPaymentPrice =
      pricewithShipping * (partialPaymentPercentage / 100) +
      getApplicableProcessingFee(processingFee, processingFeePayee);
  }

  calculatedPrice = calculatedPrice != 0 ? calculatedPrice.toFixed(2) : calculatedPrice;

  return {
    productTotalPrice: productTotalPrice,
    total: calculatedPrice,
    shippingFee,
    shippingFeeCap,
    actualShippingFee,
    paymentProcessingFee: processingFee,
    shippingFeeApplied,
    priceWithoutFees,
    couponId,
    couponCode,
    partialPaymentPrice,
  };
};

export { getPrice, truncateTo2Decimals };
